import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function SmallStubPill({ children, className }) {
  return (
    <span
      className={classNames(
        'small-stub-pill',
        'small-stub-pill--nowrap',
        'tw-text-xs',
        'tw-font-semibold',
        'tw-tracking-wide',
        className,
      )}
    >
      {children}
    </span>
  );
}

SmallStubPill.propTypes = {
  className: PropTypes.string,
};
